import React, { Fragment } from "react";
import NewNavbar from "../../new-components/NewNavbar";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import AdminUpdateBlogForm from "../../components/AdminUpdateBlogForm";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";
import NewBackButton from "../../new-components/NewBackButton";

const AdminUpdateBlog = () => {
  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />
      <NewPageHeader />
      <AdminUpdateBlogForm />
      <NewBackButton />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};
export default AdminUpdateBlog;
